








import { MapState } from '@/vuex/store';
import Vue from 'vue'
export default Vue.extend({
	

	computed: {
		working():boolean {
			const s:MapState = this.$store.state.mapState;
			// return true;
			return s == MapState.Loading || s == MapState.Saving;
		}
	}

})
